"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.aiFormAnalyzer.name': 'Analizzatore di moduli IA',
    'tools.aiFormAnalyzer.formSentByUser': 'Ho inviato il modulo.',
};
